import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { AddBoxIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { dashedButtonStyles } from './LinkOrCreateButton.styles';

const LinkOrCreateButton = ({ onClick }) => (
  <Box component="button" sx={dashedButtonStyles} type="button" onClick={onClick}>
    <AddBoxIcon size={IconSize[16]} />
    <Typography variant="medium14">Link or create a CRM contact</Typography>
  </Box>
);

LinkOrCreateButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default memo(LinkOrCreateButton);
